import React from "react";
import '../Common.scss';
import defaultImage from '../../../assets/default.png';
import styles from '../elevationElectrinics/electricalElevation.module.scss';
let keys=["name","length","code"];
let heading=["Name","Length","Code"]
export default class ElevationGasOutlet extends React.Component<any, any>{
    render() {
        const { pageDetails } = this.props;
        const { gasOutletData, elevationImage } = pageDetails || {};
        return (
            <React.Fragment>
                <div className="page-image-container">
                    <div className="page-heading">{pageDetails?.name}</div>
                    <div className="image-section-container">
                        <img crossOrigin="anonymous" src={elevationImage ? `${elevationImage}?ver=${new Date().getTime()}` :defaultImage} alt="" className="image-view" />
                    </div>
                </div>
                <div className={styles["tables-alignment"]} style={{marginTop: "15px", marginLeft: "10px"}}>
                    {gasOutletData?.length && <div className={styles.Table}>
                        <div className={styles.Heading}>
                            {heading.map((heading:string)=>(<div className={styles.Cell}>
                                <p><span className={styles['table-head']}>{heading}</span></p>
                            </div>))}
                        </div>
                        {
                            gasOutletData && gasOutletData.map(ele=>{
                                return(
                                    <div className={styles.Row}>
                                        {keys.map((key:string)=>( <div className={styles.Cell}>
                                            <p><span className={styles['table-content']}>{ele[key] || "NA"}</span></p>
                                        </div>))}
                                    </div>
                                );
                            })
                        }
                    </div>}
                </div>
            </React.Fragment>

        )
    }

}